import React from 'react'

type ProjectPageTitleProps = {
  label: string
  projectName?: string | null
}

/** Page title with a bullet before project name only when the name is non-empty. */
export default function ProjectPageTitle({ label, projectName }: ProjectPageTitleProps) {
  const name = typeof projectName === 'string' ? projectName.trim() : ''
  return (
    <>
      <span>{label}</span>
      {name ? (
        <>
          <span className="text-heritage-grey/60">•</span>
          <span className="truncate text-text-grey">{name}</span>
        </>
      ) : null}
    </>
  )
}
